import * as React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { stopInterval } from '../../helper/cacheHelper';

function Logout() {
    const navigate = useNavigate();
    const refreshPage = () => {
        stopInterval()
        localStorage.clear();
        navigate('/');
        window.location.reload();
    }
    return (
        <>
            <Link key={"logoutkey"} to="/">
                <MenuItem key={"milogout"} onClick={refreshPage}>
                    <Typography textAlign="center">
                        <LogoutIcon fontSize='small' />{"  "}
                        Logout
                    </Typography>
                </MenuItem>
            </Link>
        </>
    )
}

export default Logout;